import React from 'react';
import withShipment from '../../../withShipment';
import {
  createCompany,
  generateLicenseKey,
  getCompanyMemberships,
  getLicenseKey,
  handleRenewLicenseKey,
  listCompanies,
  listMasterAdminsPerLocation,
  revokeLicenseKey,
  updateCompany,
  updateLicensePayment,
  markCyclePaid,
} from '../../../redux/actions/settings';
import CustomToolbar from '../../global/CustomToolbar';
import {
  BACK_TO_MENU_TITLE,
  DEFAULT_ROWS_PER_PAGE,
  DEFAULT_SORT_BY_HEAD_CELL,
  CREATE_COMPANY_TITLE,
  MANAGE_COMPANY_TABLE_HEAD_CELLS,
  COMPANY_TOOLBAR_TITLE,
  PLAN_BADGE_COLORS,
} from './constants';
import CompanyWizardV3 from './CompanyWizardV3';
import Paper from '@material-ui/core/Paper';
import { IconButton } from '@material-ui/core';
import TableCell from '@material-ui/core/TableCell';
import EditIcon from '@material-ui/icons/Edit';
import { ASC, DEFAULT_PDF_ZOOM } from '../../global/constants';
import SearchableTable from '../../global/Search/SearchableTable';
import { userInfoSelector } from '../../../redux/selectors/auth';
import ErrorFeedbackBar from '../../global/ErrorFeedbackBar';
import { Layout } from '../../global/Table/TablePageHelpers/LayoutObject';
import { Tooltip } from '@mui/material';
import TablePage from '../../global/Table/TablePage';
import {
  companyMembershipsSelector,
  companySelector,
  licenseKeySelector,
  masterAdminsLocationSelector,
} from '../../../redux/selectors/account';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import ToggleOffIcon from '@mui/icons-material/ToggleOff';
import FeedbackBar from '../../feedbackBar/FeedbackBar';
import { clearStatus } from '../../../redux/actions/global';
import { statusSelector } from '../../../redux/selectors/global';
import Utils from '../../Utils/Utils';
import { globalPDFPreviewReadySelector } from '../../../redux/selectors/ticketOut';
import {
  getGlobalPDFPreview,
  resetGlobalPdfPreviewData,
} from '../../../redux/actions/ticketOut';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import { BACK } from '../../employeeSession/constants';
import { GetApp } from '@material-ui/icons';
import PrintIcon from '@mui/icons-material/Print';
import ZoomOutIcon from '@material-ui/icons/ZoomOut';
import ZoomInIcon from '@material-ui/icons/ZoomIn';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import RenderPurchaseOrderPDFPreview from '../../transaction/RenderPurchaseOrderPDFPreview';
import AssignmentIcon from '@mui/icons-material/Assignment';
import MembershipSummary from './MembershipSummary';
import PaymentHistoryDialog from './PaymentHistoryDialog';
import ReceiptIcon from '@mui/icons-material/Receipt';
import { getRoles } from '../../../redux/actions/userManagement';
import { rolesSelector } from '../../../redux/selectors/userManagement';

class ManageCompanyTable extends SearchableTable {
  constructor(props) {
    super(props);
    this.membershipRef = React.createRef();
    this.state = {
      page: 0,
      rowsPerPage: DEFAULT_ROWS_PER_PAGE,
      addingCompany: false,
      editingCompany: null,
      order: ASC,
      orderBy: DEFAULT_SORT_BY_HEAD_CELL,
      isSearch: false, // true if search value is not empty, false otherwise
      searchValue: '', // the value in the search field (updates on change)
      searchRows: 0, // number of rows displayed while search criteria is met
      //PRINT
      showPdfViewer: false,
      pdfLoadSuccess: true,
      pdfData: [],
      scale: DEFAULT_PDF_ZOOM,
      isSummary: false,
      paymentHistoryOpen: false,
      paymentHistoryCompany: null,
    };
  }

  openPaymentHistory = (row) => {
    this.setState({
      paymentHistoryOpen: true,
      paymentHistoryCompany: row,
    });
  };

  closePaymentHistory = () => {
    this.setState({
      paymentHistoryOpen: false,
      paymentHistoryCompany: null,
    });
  };

  componentDidMount() {
    this.props.listCompanies();
    this.props.getRoles({
      locationId: this.props.userInfo.selectedLocationId,
      type: 'company',
    });
  }

  async componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      this.props.status.statusText &&
      prevProps.status.statusText !== this.props.status.statusText
    ) {
      this.openFeedbackBar();
    }
    if (
      !this.arrayEquals(prevProps.PDFPreviewReady, this.props.PDFPreviewReady)
    ) {
      this.setState({
        pdfData: this.props.PDFPreviewReady,
      });
    }
  }

  //report

  showPdfErrorMessage = (isFailed) => {
    this.props.resetGlobalPdfPreviewData();
    this.setState({ pdfLoadSuccess: !isFailed });
  };

  closePdfViewer = () => {
    this.setState({ showPdfViewer: false, pdfData: '' }); // Close the PDF viewer and reset URL
  };

  download = () => {
    const date = new Date();
    const getTodayDate = Utils.formatTodayDate(date);
    const fileName = `${this.props.userInfo.firstname} Active Membership Report - ${getTodayDate}.pdf`;

    Utils.handlePdfAction(this.state.pdfData, 'download', fileName);
  };

  setZoom(zoom) {
    let newScale = Math.min(Math.max(this.state.scale + zoom, 1), 2);
    this.setState({
      scale: newScale,
    });
  }

  arrayEquals(arr1, arr2) {
    if (!arr1 || !arr2) return false;
    if (arr1.length !== arr2.length) return false;
    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) return false;
    }
    return true;
  }

  fetchPdf = async () => {
    this.props.getGlobalPDFPreview(
      null,
      this.showPdfErrorMessage,
      'previewActiveMembership'
    );

    this.setState({ showPdfViewer: true });
  };

  //end report

  openFeedbackBar = (status, message) => {
    this.setState({
      feedbackStatus: status,
      feedbackMessage: message,
      feedbackBarOpen: true,
    });
  };

  closeFeedbackBar = () => {
    this.setState(
      { feedbackBarOpen: false, feedbackStatus: '', feedbackMessage: '' },
      () => {
        this.props.clearStatus();
      }
    );
  };

  handleOpenCompany = (row) => {
    this.setState({
      editingCompany: row,
    });
  };

  handleClose = () => {
    this.setState(
      {
        addingCompany: false,
      },
      () => this.setState({ editingCompany: null })
    );
  };

  handleSave = (addingCompany, data, onSuccess) => {
    // CompanyWizardV3 handles its own validation before invoking onSave,
    // so the table only forwards the payload to the appropriate action.
    const dataToPost = { ...data };
    if (addingCompany) {
      this.props.createCompany(dataToPost, () => {
        if (onSuccess) onSuccess();
        window.location.reload();
      });
    } else {
      const updatePayload = { ...data, companyId: data.companyId };
      this.props.updateCompany(updatePayload, () => {
        if (onSuccess) onSuccess();
        this.setState({ addingCompany: false }, () =>
          this.setState({ editingCompany: null })
        );
      });
    }
  };

  getTableHeaders = () => {
    let headers = [];
    headers.push(Layout.columnHead(null, null, null));
    MANAGE_COMPANY_TABLE_HEAD_CELLS.forEach((headCell) => {
      headers.push(Layout.columnHead(headCell.label, headCell.id, 'center'));
    });
    return headers;
  };

  creatingCompany = () => {
    this.setState({
      addingCompany: true,
    });
  };

  cancelCompany = () => {
    this.setState({
      addingCompany: false,
      editingCompany: false,
    });
  };

  viewMembershipSummary = () => {
    this.setState({
      isSummary: true,
    });
  };

  closeMembershipSummary = () => {
    this.setState({
      isSummary: false,
    });
  };

  render() {
    const { showPdfViewer, pdfData, scale, isSummary } = this.state;

    let headerButtons = [];

    if (showPdfViewer) {
      headerButtons.push(
        {
          icon: <KeyboardBackspaceIcon />,
          handler: () => this.closePdfViewer(),
          title: BACK,
        },
        {
          icon: <GetApp />,
          handler: () => this.download(),
          title: 'Download PDF',
        },
        {
          icon: <PrintIcon />,
          title: 'Print PDF',
          handler: () => {
            if (!this.state.pdfData) return;
            Utils.handlePdfAction(
              this.state.pdfData,
              'print',
              'company-report-print.pdf'
            );
          },
        },
        {
          icon: <ZoomOutIcon />,
          handler: () => this.setZoom(-0.25),
          title: 'Zoom Out',
          disabled: false,
        },
        {
          divider: (
            <span style={{ padding: '5px', marginTop: '5px' }}>
              {this.state.scale * 100}%
            </span>
          ),
        },
        {
          icon: <ZoomInIcon />,
          handler: () => this.setZoom(0.25),
          title: 'Zoom In',
          disabled: false,
        }
      );
    } else if (isSummary) {
      headerButtons = [
        {
          icon: <KeyboardBackspaceIcon />,
          handler: this.closeMembershipSummary,
          title: 'Back',
        },
        {
          icon: <GetApp />,
          handler: () => {
            if (
              this.membershipRef.current &&
              this.membershipRef.current.downloadPDF
            ) {
              this.membershipRef.current.downloadPDF();
            }
          },
          title: 'Download PDF',
        },
      ];
    } else {
      if (!this.state.editingCompany && !this.state.addingCompany) {
        headerButtons = [
          {
            icon: <AddCircleIcon />,
            handler: this.creatingCompany,
            title: 'Create new company',
          },
          {
            icon: <AssignmentIcon />,
            title: 'Membership Summary',
            handler: () => this.viewMembershipSummary(),
          },
        ];
      } else {
        headerButtons = [
          {
            icon: <KeyboardBackspaceIcon />,
            handler: this.cancelCompany,
            title: 'Back',
          },
        ];
      }
    }

    return (
      <>
        <Paper className="paper">
          <FeedbackBar
            open={this.state.feedbackBarOpen}
            handleClose={this.closeFeedbackBar}
            severity={this.state.feedbackStatus}
            message={this.state.feedbackMessage}
          />
          <ErrorFeedbackBar />
          <CustomToolbar
            title={
              isSummary
                ? 'Membership Summary'
                : this.state.addingCompany
                ? 'Create Company'
                : this.state.editingCompany
                ? `Edit ${this.state.editingCompany.name || ''}`.trim()
                : COMPANY_TOOLBAR_TITLE
            }
            createTitle={CREATE_COMPANY_TITLE}
            backTitle={BACK_TO_MENU_TITLE}
            onClick={() => {
              this.setState({ addingCompany: true });
            }}
            handleClose={this.handleClose}
            headerButtons={headerButtons}
          />

          {this.state.isSummary ? (
            <MembershipSummary
              ref={this.membershipRef}
              memberships={this.props.companyMemberships}
              getCompanyMemberships={this.props.getCompanyMemberships}
              updateLicensePayment={this.props.updateLicensePayment}
              markCyclePaid={this.props.markCyclePaid}
            />
          ) : showPdfViewer ? (
            <RenderPurchaseOrderPDFPreview
              data={pdfData}
              handleSubmit={this.handleSubmit}
              creating={true}
              handlePdfLoadSuccess={this.props.handlePdfLoadSuccess}
              handlePdfLoadError={this.props.handlePdfLoadError}
              scale={scale}
            />
          ) : !this.state.editingCompany ? (
            this.state.addingCompany ? (
              <CompanyWizardV3
                companies={this.props.companies}
                onClose={this.handleClose}
                onSave={(payload, onSuccess) =>
                  this.handleSave(true, payload, onSuccess)
                }
              />
            ) : (
              <>
                <TablePage
                  tableName="companyTable"
                  tableRows={[...(this.props.companies || [])].sort((a, b) => {
                    if (a.name === 'NuVe System') return -1;
                    if (b.name === 'NuVe System') return 1;
                    return 0;
                  })}
                  tableColumnHeads={this.getTableHeaders()}
                  tableRow={(row, index) => {
                    const isNDS = row.name === 'NuVe System';
                    // Testing companies (anything with "testing" in the
                    // name, case-insensitive) are internal and never
                    // billed — hide payment history same as NDS.
                    const isTesting = (row.name || '')
                      .toLowerCase()
                      .includes('testing');
                    const isOwner =
                      this.props.userInfo?.authority?.includes('ROLE_OWNER');
                    const canEdit = !isNDS || isOwner;
                    return (
                      <React.Fragment>
                        <TableCell
                          style={{
                            textAlign: 'center',
                            width: '1%',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {canEdit && (
                            <Tooltip title={'Edit company'}>
                              <IconButton
                                onClick={() => this.handleOpenCompany(row)}
                              >
                                <EditIcon fontSize="medium" />
                              </IconButton>
                            </Tooltip>
                          )}
                          {!isNDS && !isTesting ? (
                            <Tooltip title={'Payment history'}>
                              <IconButton
                                onClick={() => this.openPaymentHistory(row)}
                              >
                                <ReceiptIcon fontSize="medium" />
                              </IconButton>
                            </Tooltip>
                          ) : (
                            // Invisible placeholder so the edit icon stays
                            // x-aligned across rows that hide the receipt
                            // button (NDS, testing companies).
                            <IconButton
                              disabled
                              style={{ visibility: 'hidden' }}
                              aria-hidden="true"
                            >
                              <ReceiptIcon fontSize="medium" />
                            </IconButton>
                          )}
                        </TableCell>
                        <TableCell style={{ textAlign: 'center' }}>
                          {row.companyCode
                            ? `${row.name} (${row.companyCode})`
                            : row.name}
                        </TableCell>

                        <TableCell style={{ textAlign: 'center' }}>
                          {row?.planName ? (
                            <span
                              style={{
                                display: 'inline-block',
                                padding: '4px 10px',
                                borderRadius: '999px',
                                color: '#fff',
                                fontSize: '12px',
                                fontWeight: 700,
                                letterSpacing: '0.3px',
                                background:
                                  PLAN_BADGE_COLORS[row.planName] || '#6B7280',
                              }}
                            >
                              {row.planName}
                            </span>
                          ) : null}
                        </TableCell>

                        <TableCell style={{ textAlign: 'center' }}>
                          {row?.status === 'active' ? (
                            <Tooltip title="Active">
                              <ToggleOnIcon
                                style={{ color: 'green', fontSize: '36px' }}
                              />
                            </Tooltip>
                          ) : row?.status === 'closed' ? (
                            <Tooltip title="Closed">
                              <ToggleOffIcon
                                style={{ color: 'red', fontSize: '36px' }}
                              />
                            </Tooltip>
                          ) : (
                            <Tooltip title="Hold">
                              <ToggleOffIcon
                                style={{ color: 'orange', fontSize: '36px' }}
                              />
                            </Tooltip>
                          )}
                        </TableCell>
                      </React.Fragment>
                    );
                  }}
                  onRowDoubleClick={(row) => {
                    const isNDS = row.name === 'NuVe System';
                    const isOwner =
                      this.props.userInfo?.authority?.includes('ROLE_OWNER');
                    if (!isNDS || isOwner) this.handleOpenCompany(row);
                  }}
                />
              </>
            )
          ) : (
            <CompanyWizardV3
              mode="edit"
              editingCompany={this.state.editingCompany}
              companies={this.props.companies}
              licenseKey={this.props.licenseKey}
              getLicenseKey={this.props.getLicenseKey}
              handleRenewLicenseKey={this.props.handleRenewLicenseKey}
              revokeLicenseKey={this.props.revokeLicenseKey}
              listCompanies={this.props.listCompanies}
              onClose={this.handleClose}
              onSave={(payload, onSuccess) =>
                this.handleSave(false, payload, onSuccess)
              }
            />
          )}
        </Paper>
        <PaymentHistoryDialog
          open={this.state.paymentHistoryOpen}
          companyId={this.state.paymentHistoryCompany?.companyId}
          companyName={this.state.paymentHistoryCompany?.name}
          onClose={this.closePaymentHistory}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  status: statusSelector(state),
  companies: companySelector(state),
  userInfo: userInfoSelector(state),
  licenseKey: licenseKeySelector(state),
  PDFPreviewReady: globalPDFPreviewReadySelector(state),
  companyMemberships: companyMembershipsSelector(state),
  roles: rolesSelector(state),
  masterAdminsLocation: masterAdminsLocationSelector(state),
});

const actionCreators = {
  clearStatus,
  createCompany,
  updateCompany,
  listCompanies,
  generateLicenseKey,
  handleRenewLicenseKey,
  getLicenseKey,
  revokeLicenseKey,
  getGlobalPDFPreview,
  resetGlobalPdfPreviewData,
  getCompanyMemberships,
  updateLicensePayment,
  markCyclePaid,
  getRoles,
  listMasterAdminsPerLocation,
};

export default withShipment(
  {
    mapStateToProps,
    actionCreators,
  },
  ManageCompanyTable
);
